import React from 'react';

interface StatTileProps {
  label: string;
  value: React.ReactNode;
  hint?: React.ReactNode;
  children?: React.ReactNode;
}

const StatTile: React.FC<StatTileProps> = ({ label, value, hint, children }) => (
  <div className="rounded-2xl border border-school-line bg-school-surface p-4">
    <div className="text-sm font-medium text-school-muted">{label}</div>
    <div className="mt-1 text-3xl font-extrabold text-school-ink tabular-nums">{value}</div>
    {hint && <div className="mt-1 text-xs text-school-muted">{hint}</div>}
    {children && <div className="mt-3">{children}</div>}
  </div>
);

export default StatTile;
